// extracted by mini-css-extract-plugin
export default {"root":"forgot-password_root__Zvsnk","title":"forgot-password_title__VU6Kt","form":"forgot-password_form__Z-Kr3","submitButton":"forgot-password_submitButton__PikND"};